import React, { Fragment } from "react";
import { Link } from "react-router-dom";

const SeguroCancelacion = ({ onIncluirSeguroDeCancelacionClick }) => {
  return (
    <Fragment>
      <h2>Seguro de Cancelaci&oacute;n</h2>
      <hr />
      <h4>
        <i className="material-icons iconos-pagos">beenhere</i> El seguro de
        cancelación por enfermedad tiene un valor del 10% del total del tour. Para contratarlo
        haga click abajo y estará aceptando las{" "}
        <Link to="/terminos-y-condiciones#seguro" target="_blank">
          condiciones
        </Link>{" "}
        del mismo
      </h4>
      <ul>
        <li>
          <input
            className="styled-checkbox"
            id="tos-seguro"
            name="seguroCancelacion"
            onChange={onIncluirSeguroDeCancelacionClick}
            type="checkbox"
          />
          <label htmlFor="tos-seguro">
            Agregar Seguro de Cancelaci&oacute;n
          </label>
        </li>
      </ul>
    </Fragment>
  );
};

export default SeguroCancelacion;



// WEBPACK FOOTER //
// ./src/components/ProcesoCompra/Pago/seguroCancelacion.js